// builderUtils.js
// Generates a STABLE id for any DOM element based on its tag + a positional
// path from the document root, so overrides survive reloads and route changes.

export const EDITABLE_SELECTOR =
    "h1,h2,h3,h4,h5,h6,p,img,a,span,button,li,[data-ve-editable]";

function pathOf(el) {
    const parts = [];
    let node = el;
    while (node && node.nodeType === 1 && node !== document.body) {
        let index = 1;
        let sib = node.previousElementSibling;
        while (sib) {
            if (sib.tagName === node.tagName) index++;
            sib = sib.previousElementSibling;
        }
        parts.unshift(`${node.tagName.toLowerCase()}:${index}`);
        node = node.parentElement;
    }
    return parts.join(">");
}

export function idForElement(el) {
    if (!el) return null;
    const tag = el.tagName.toLowerCase();
    const key = el.getAttribute("data-testid");
    if (key) return `${tag}#${key}`;
    return `${tag}@${pathOf(el)}`;
}

export function isImage(el) {
    return el.tagName === "IMG";
}

// Collect every editable element currently in the DOM.
export function collectEditable(root = document) {
    return Array.from(root.querySelectorAll(EDITABLE_SELECTOR)).filter((el) => {
        // skip the builder's own UI
        if (el.closest("[data-ve-builder]")) return false;
        // skip empty/decoration-only spans without text and without image
        if (el.tagName === "SPAN" && !el.querySelector("img")) {
            const t = (el.textContent || "").trim();
            if (!t) return false;
        }
        return true;
    });
}
